import { SxProps } from "@mui/material";

export const subscriptionEmailSX: SxProps = {
    height: '40px',
    boxSizing: 'border-box',
    borderRadius: '5px',
    color: '#000000',
    paddingLeft: '10px',
    paddingBottom: '18px',
    outline: 'none',
    width: '100%',
	maxWidth: '360px',
	marginTop: '4px',
	fontSize: '16px'
}

export const subscribeButtonSX: SxProps = {
    fontWeight: 'bold',
    fontSize:'20px',
    padding: '0 10px',
    textAlign: 'center',
    lineHeight: '42px',
    maxWidth: '360px',
    width: '100%',
    height:'40px',
    outline:'none',
    cursor:'pointer',
    borderRadius:'5px',
    marginTop:'20px',
   // bgcolor: '#fd0',
    color: '#ffffff',
    //backgroundColor: '#000000',	
    boxSizing: 'border-box'
}

